export default __webpack_public_path__ + "rosette.9fc6b534f9ff21b9.svg";